// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PercentIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PercentIcon" ref={forwardedRef} {...props}>
      <path d="M6.16 9.305c-1.672 0-2.66-1.172-2.66-3.278S4.488 2.75 6.16 2.75c1.714 0 2.681 1.172 2.681 3.277s-.967 3.278-2.68 3.278M4.105 15.64l10.4-12.414 1.39 1.152-10.38 12.414zm.947-9.614c0 1.351.403 2.007 1.108 2.007.726 0 1.13-.656 1.13-2.007 0-1.31-.404-1.986-1.13-1.986-.705 0-1.108.675-1.108 1.986m6.107 7.946c0-2.106.987-3.278 2.66-3.278 1.714 0 2.681 1.172 2.681 3.278s-.967 3.277-2.68 3.277c-1.674 0-2.661-1.172-2.661-3.277m1.552 0c0 1.35.403 2.006 1.108 2.006.726 0 1.13-.656 1.13-2.006 0-1.311-.404-1.987-1.13-1.987-.705 0-1.108.676-1.108 1.987" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PercentIcon = /* @__PURE__ */ Object.assign(PercentIconComponent, {
  displayName: 'PercentIcon',
});
